var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.funcionFiltrar }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.lstClientesProveedores,
                    "exported-file-name": "ClientesProveedoresDeGPS"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridTodos", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad,
              "row-data": _vm.lstClientesProveedores
            },
            on: {
              gridOptionsEnriched: function($event) {
                _vm.enrichedGridOptions = $event
              }
            }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarAsociacionesEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.mensajeAsociacionEliminar,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleCierreEliminar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarRecepcionesEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.mensajeRecepcionesEliminar,
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: { modalConfirmationEmit: _vm.handleCierreEliminar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "el Cliente Proveedor de GPS"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c("CrearClienteProveedorModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: { cerrar: _vm.handleCierreModalCrear }
      }),
      _c("VerClienteProveedorModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          clienteProveedorSeleccionado: _vm.clienteProveedorSeleccionado
        },
        on: { cerrar: _vm.handleCierreModalVer }
      }),
      _c("EditarClienteProveedorModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          clienteProveedorSeleccionado: _vm.clienteProveedorSeleccionado
        },
        on: { cerrar: _vm.handleCierreModalEditar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }